import { doc, updateDoc } from "firebase/firestore";
import { db } from "../../../firebase";
import HelperForMetaData from "../../../Helpers/HelperForMetaData";

const UpdateCourse = async (FormData, CourseID) => {
  try {
    const CourseDocument = doc(db, "Courses", CourseID);

    const data = {
      ...FormData,
      ...HelperForMetaData({}),
    };

    delete data.createdAt;
    delete data.createdBy;

    await updateDoc(CourseDocument, data);

    return true;
  } catch (error) {
    console.log(error);

    return false;
  }
};

export default UpdateCourse;
